import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useRenewalStartAssessment = (
  isLoading,
  isStarted,
  transactionStatus,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed =
    ['FOR CHECKING', 'COMPUTED'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['FOR PERMIT PROCESS'].indexOf(applicationStatus) > -1;

  const isAllowed = true && isStatusAllowed && isApplicationStatusAllowed;

  const onStartAssessment = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want ${isStarted ? 'Stop' : 'Start'} assessment?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = isAllowed ? (
    <div className="mx-2">
      <button
        disabled={isLoading}
        onClick={onStartAssessment}
        type="button"
        className={`btn ${
          isStarted
            ? 'btn-danger'
            : 'btn-primary cms-bg-color-primary cms-outline-primary    '
        } font-weight-bold`}
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        {isStarted ? `Stop` : `Start`} Assessment{' '}
        <i className={`fas ${isStarted ? 'fa-times' : 'fa-check'}`} />
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onStartAssessment,
    component,
  };
};

export default useRenewalStartAssessment;
